var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./JsonExcel.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler?id=data-v-1e035cf0!../vue-loader/lib/selector?type=template&index=0!./JsonExcel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-json-excel/JsonExcel.vue
// module id = 467
// module chunks = 55